import React, { ReactNode, ReactElement } from 'react';
import { css } from '@emotion/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { Checkbox } from '../../Forms/Checkbox';
import { TextField } from '../../TextField/component';
import { LoginSignupContext } from '../context';

import './styles.scss';

export const ReduxFormSubmitButton = React.memo(
  ({
    label,
    submitting,
    disabled,
  }: {
    label: string;
    submitting: boolean;
    disabled?: boolean;
  }): ReactElement => (
    <LoginSignupContext.Consumer>
      {({ ctaColor }) => (
        <button
          type="submit"
          className="login-signup-submit-button"
          css={css({ background: ctaColor })}
          disabled={disabled}
        >
          {submitting && <FontAwesomeIcon icon={faSpinner} spin pulse />}{' '}
          {label}
        </button>
      )}
    </LoginSignupContext.Consumer>
  )
);

declare type ReduxFormFieldProps = {
  input: {
    checked?: boolean;
    name: string;
    onBlur: () => void;
    onChange: () => void;
    value: string;
  };
  label: ReactNode;
  placeholder: string;
  type: 'checkbox' | 'text' | 'password';
  meta: {
    touched: boolean;
    error?: string;
    warning?: string;
  };
};

export const ReduxFormField = React.memo(
  ({
    input: { checked, name, onChange, value },
    label,
    type,
    meta: { touched, error },
  }: ReduxFormFieldProps): ReactElement => {
    if (type === 'checkbox') {
      return (
        <Checkbox
          {...{ name, checked, onChange }}
          label={label}
          error={touched ? error : null}
        />
      );
    }

    return (
      <TextField
        {...{ name, label, type, value, onChange }}
        error={touched ? error : null}
      />
    );
  }
);

export const ReduxFormError = React.memo(
  ({ error }: { error: string }): ReactElement => (
    <div className="login-signup-form-error">{error}</div>
  )
);

export const ForgotPasswordLink = React.memo(
  ({ onForgotPassword }: { onForgotPassword: () => void }): ReactElement => (
    <div className="login-signup-forgot-password-link">
      <button type="button" onClick={onForgotPassword}>
        Forgot password
      </button>
    </div>
  )
);
